import type { Alpha3Code } from "i18n-iso-countries/index"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"
import type { DateISOString } from "./util/date-iso-string"

export const NATIONAL_IDENTIFICATION_TYPES = [
  "Drivers License",
  "National ID",
  "Passport",
] as const

export type NationalIdentificationType =
  (typeof NATIONAL_IDENTIFICATION_TYPES)[number]

export class NationalIdentification {
  identificationNumber = ""
  identificationType?: NationalIdentificationType
  issuingCountry?: Alpha3Code
  issueDate?: DateISOString | null
  expiryDate?: DateISOString | null
}

export const NATIONAL_IDENTIFICATION_DESER: SchemaDeSer<NationalIdentification> =
  new SchemaDeSerBuilder(NationalIdentification)
    .ofString("identificationNumber")
    .ofString("identificationType")
    .ofString("issuingCountry")
    .ofString("issueDate")
    .ofString("expiryDate")
    .toDeSer()
